

import React, { memo } from 'react';
import cx from 'classnames';
import { Icon } from '../../../ui-kit';
import '../styles/_projectTypeIcon.scss';








function ProjectIconType({
  iconName,
  iconSize = 16,
  name = 'video',
  iconColour = 'white'
}) {
  return (
    <Icon
      name={iconName}
      size={iconSize}
      color={iconColour}
      className={cx('project-icon-type', { [`project-icon-type--${name}`]: name })} />);


}

export default memo(ProjectIconType);